module.exports = __webpack_public_path__ + "assets/images/3-1Rd-kGF.jpg";